import { observable, makeObservable, runInAction, action } from 'mobx';
import { getAgreement } from '../api/privacy';

class Privacy {
    constructor() {
        makeObservable(this);
    }

    @observable
    loading = false;

    @action
    setLoading = (v) => {
        this.loading = v;
    };

    @observable
    privacyInfo = null;

    getAgreement = async (terrace) => {
        this.setLoading(true);
        const { data, code } = await getAgreement(terrace);
        if (code === '00000') {
            runInAction(() => {
                this.privacyInfo = data.content;
            });
        } else {
            runInAction(() => {
                this.privacyInfo = null;
            });
        }
        this.setLoading(false);
    };
}
export default new Privacy();
